import { DesignApi, Configuration, ImageRatio } from '@/rest'
import { PaintingByNumbersModule } from '@/store/modules/paintingByNumbers';

export default function getImageRatios(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        let designApi = new DesignApi(
            new Configuration({ basePath: '/rest'})
        )
        designApi.getImageRatios().then(
            (value) => {
                PaintingByNumbersModule.SetImageRatios(createImageRatioMap(value))
                resolve()
            },
            (reason) => {
                window.console.log(reason)
                reject()
            });
    });
}

function createImageRatioMap(imageRatios: ImageRatio[]): Map<string, ImageRatio> {
    let result: Map<string, ImageRatio> = new Map()
    for(let ratio of imageRatios) {
        if(ratio.parts) {
            result.set(ratio.parts, ratio)
        }
    }
    return result
}